import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useNavigate, useLocation } from "react-router-dom";
import NoMatchSection from "./no-match-section";
import StockMatchSummary from "./stock-match-chart";
import { useSelector, useDispatch } from "react-redux";
import {
  setManualStockListRedux,
  setHinNumberRedux,
  setIsFetchRedux,
  setIsFetchExistRedux,
  setIsFetchStrategyRedux,
  setIsMatchFoundRedux,
  setManualEntryVisibleRedux,
  setPortfolioListRedux,
  setStockListRedux,
} from "../../Redux/store/inspecie-transfer";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";

const LoadStocks = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const hinNumberRedux = useSelector(
    (state) => state.inspecieTransfer.hinNumber
  );
  const userId = useSelector((state) => state.user.userId);

  const [hinNumber, setHinNumber] = useState(hinNumberRedux);
  const isFetchRedux = useSelector((state) => state.inspecieTransfer.isFetch);
  const [isFetch, setIsFetch] = useState(isFetchRedux);
  const isFetchStrategyRedux = useSelector(
    (state) => state.inspecieTransfer.isFetchStrategy
  );

  const [isFetchStrategy, setIsFetchStrategy] = useState(isFetchStrategyRedux);
  const [isFetchStrategyCheck, setIsFetchStrategyCheck] = useState(false);
  const isFetchExistRedux = useSelector(
    (state) => state.inspecieTransfer.isFetchExist
  );

  const [isfetchExist, setIsFetchExist] = useState(isFetchExistRedux);
  const isMatchFoundRedux = useSelector(
    (state) => state.inspecieTransfer.isMatchFound
  );
  const [isMatchFound, setIsMatchFound] = useState(isMatchFoundRedux);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const manualEntryVisibleRedux = useSelector(
    (state) => state.inspecieTransfer.manualEntryVisible
  );
  const [manualEntryVisible, setManualEntryVisible] = useState(
    manualEntryVisibleRedux
  );
  const [manualStockCode, setManualStockCode] = useState("");
  const [manualQuantity, setManualQuantity] = useState("");
  const [manualStockName, setManualStockName] = useState("");
  const manualStockListRedux = useSelector(
    (state) => state.inspecieTransfer.manualStockList
  );
  const [manualStockList, setManualStockList] = useState(manualStockListRedux);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dispatch = useDispatch();
  const portfolioListRedux = useSelector(
    (state) => state.inspecieTransfer.portfolioList
  );
  const [portfolioAccounttableData, setPortfolioAccounttableData] = useState([
    portfolioListRedux,
  ]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showRecords, setShowRecords] = useState(10);
  const [filterText, setFilterText] = useState("created_at");
  const [editIndex, setEditIndex] = useState(null);
  const [file, setFile] = useState(null);

  const [editCode, setEditCode] = useState("");
  const [editQuantity, setEditQuantity] = useState("");
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [manualPurchasedDate, setManualPurchasedDate] = useState("");
  const [editPurchasedDate, setEditPurchasedDate] = useState("");
  const [nearestStrategies, setNearestStrategies] = useState([]);
  const stockListRedux = useSelector(
    (state) => state.inspecieTransfer.stockList
  );
  const [stockData, setStockData] = useState(stockListRedux);
  const requestIdRedux = useSelector(
    (state) => state.inspecieTransfer.requestId
  );
  const [currentPageUnallocated, setCurrentPageUnallocated] = useState(1);
  const [showRecordsUnallocated, setShowRecordsUnallocated] = useState(10);
  const [totalPagesUnallocated, setTotalPagesUnallocated] = useState(0);
  const [totalCountUnallocated, setTotalCountUnallocated] = useState(0);
  const [preSelectedFilterUnallocated, setpreSelectedFilterUnallocated] =
    useState({
      value: 10,
      label: "10",
    });
  function formatDateTime(inputDateStr) {
    const date = new Date(inputDateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const yyyy = date.getFullYear();

    const HH = String(date.getHours()).padStart(2, "0");
    const MM = String(date.getMinutes()).padStart(2, "0");
    const SS = String(date.getSeconds()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy}`;
  }
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setpreSelectedFilterUnallocated(selectedOption);
    setShowRecordsUnallocated(parseInt(selectedOption.value));
    setCurrentPageUnallocated(1);
  };
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const portfolioAccountheaders = [
    { label: "Investment ID", key: "investment ID" },
    { label: "Investment Product Name", key: "productName" },
    { label: "Matched %", key: "Matched" },
    { label: "Minimum Investment Amount", key: "Matched" },
  ];
  const unallocatedHeaders = [
    { label: "Code", key: "stock_asx" },
    { label: "Name", key: "email_address" },
    { label: "Quantity", key: "quantity" },
    { label: "Purchased Date", key: "purchase_date" },
    { label: "Status", key: "purchase_date" },
  ];
  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleSort = (key) => {
    setFilterText(key);
  };
  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }
  const handleAddManualStock = () => {
    if (!manualStockCode || !manualQuantity || !manualPurchasedDate) return;

    const newStock = {
      code: manualStockCode.toUpperCase(),
      stock_name: manualStockName || "Custom Stock",
      quantity: parseInt(manualQuantity),
      purcahsed_date: manualPurchasedDate,
    };

    setManualStockList([...manualStockList, newStock]);
    setManualStockCode("");
    setManualQuantity("");
    setManualStockName("");
    setManualPurchasedDate("");
    setIsFetchStrategyCheck(false);
    setIsFetchStrategy(false);
    dispatch(setIsFetchStrategyRedux(true));
    dispatch(setManualStockListRedux([...manualStockList, newStock]));
  };
  const handleEdit = (index) => {
    const item = manualStockList[index];
    setEditCode(item.code);
    setEditQuantity(item.quantity);
    setEditPurchasedDate(item.purcahsed_date || "");
    setEditIndex(index);
  };

  const handleUpdateSave = (index) => {
    const updatedList = [...manualStockList];
    updatedList[index] = {
      ...updatedList[index],
      code: editCode.toUpperCase(),
      quantity: Number(editQuantity),
      purcahsed_date: editPurchasedDate,
    };
    setManualStockList(updatedList);
    setEditIndex(null);
    setIsFetchStrategyCheck(false);
    setIsFetchStrategy(false);
    dispatch(setIsFetchStrategyRedux(false));
    dispatch(setManualStockListRedux(updatedList));
  };

  const handleFinalSubmit = () => {
    setIsSubmitted(true);
  };
  const handleDeleteManualStock = (indexToDelete) => {
    const updatedList = manualStockList.filter(
      (_, index) => index !== indexToDelete
    );
    setManualStockList(updatedList);
    setIsFetchStrategyCheck(false);
    setIsFetchStrategy(false);
    dispatch(setIsFetchStrategyRedux(false));
    dispatch(setManualStockListRedux(updatedList));
  };
  const fetchStockApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/strategy-recommendation`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const fetchStrategiesApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/strategy-recommendation?size=${showRecords}&page=${currentPage}&search=${searchQuery}`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const UploadStockApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/bulk-submit`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const convertedArray = manualStockList.map((item) => ({
      user_id: userId, // or dynamically set
      asx_code: item.code,
      quantity: item.quantity,
      purchase_date: item.purcahsed_date, // match the key or fix typo if needed
      purcahse_price: "", // or assign actual price if available
      notres: "", // add notes if needed
    }));
    const bodyData = convertedArray;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleFetchStocks = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseStock = await UploadStockApi();
        if (responseStock.status == 201) {
          fetchStocks();
          getAllUserUnallocatedAccounts();
        } else {
          toastMessage = { message: responseStock.message, type: "error" };
        }
      } catch (err) {
        setIsFetchStrategy(false);
        setIsFetchStrategyCheck(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [hinNumber, manualStockList, showRecords, currentPage, searchQuery] // Dependencies
  );
  const fetchStocks = async () => {
    let toastMessage = null;
    try {
      setIsLoadingPortfolio(true);
      const responseStrategies = await fetchStrategiesApi();
      if (responseStrategies.status == 200) {
        // if (
        //   !manualEntryVisible &&
        //   responseStrategies.data.request_stocks.length > 0
        // ) {
        //   dispatch(setIsFetchRedux(true));
        //   dispatch(setIsFetchExistRedux(true));
        //   setIsFetch(true);
        //   setIsFetchExist(true);
        // }
        // setStockData(responseStrategies.data.request_stocks);
        // dispatch(setStockListRedux(responseStrategies.data.request_stocks));
        setPortfolioAccounttableData(responseStrategies.data.data);
        dispatch(setPortfolioListRedux(responseStrategies.data.data));
        setIsMatchFound(true);
        dispatch(setIsMatchFoundRedux(true));
        settotalPages(responseStrategies.data.pagination.total_pages);
        settotalCount(responseStrategies.data.pagination.total_strategies);
        //mum
        setIsFetchStrategy(true);
        setIsFetchStrategyCheck(true);
      } else {
        toastMessage = { message: responseStrategies.message, type: "error" };
      }
    } catch (err) {
      setIsFetchStrategy(false);
      setIsFetchStrategyCheck(false);
      setPortfolioAccounttableData([]);
      setNearestStrategies([]);
      dispatch(setPortfolioListRedux([]));
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setTimeout(() => {
        setIsLoadingPortfolio(false);
        if (toastMessage) {
          showToast(toastMessage.message, toastMessage.type);
        }
      }, 300); // Small delay if needed
    }
  };
  const GetUnallocatedList = async () => {
    const token = localStorage.getItem("jwtToken");
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/submissions/${userId}?page=${currentPageUnallocated}&size=${showRecordsUnallocated}`;

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllUserUnallocatedAccounts = async () => {
    try {
      setIsLoading(true);
      const response = await GetUnallocatedList();
      if (response.status == 200) {
        setStockData(response.data.submissions);
        dispatch(setStockListRedux(response.data.submissions));
        setTotalPagesUnallocated(response.data.total_pages);
        setTotalCountUnallocated(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const formatDateForFilterNew = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`; // Format as yyyy-dd-mm
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/bulk-submit/csv`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleDeleteFile = () => {
    setFile(null);
  };
  const handleStockCSV = useCallback(
    debounce(async (e, file) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UploadCSVApi(file);
        if (response.status == "201") {
          toastMessage = {
            message: "Data added successfully",
            type: "success",
          };
          setCurrentPageUnallocated(1);
          getAllUserUnallocatedAccounts();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setIsFetchStrategy(false);
        setIsFetchStrategyCheck(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [file] // Dependencies
  );
  const downloadExcelReportHistoricalPerformance = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(
        `${BASE_URL}/v1/merchant/dashboard/external-stocks/bulk-submit/sample-csv`,
        {
          method: "GET",
          headers,
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleSampleCSV = useCallback(
    debounce(async () => {
      try {
        const csvBlob = await downloadExcelReportHistoricalPerformance();
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Sample csv template.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        setTimeout(function () {
          setLoading(false); // Ensure `loading` is false first
        }, 100);
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  useEffect(() => {
    fetchStocks();
  }, [showRecords, currentPage, searchQuery]);
  useEffect(() => {
    getAllUserUnallocatedAccounts();
  }, [showRecordsUnallocated, currentPageUnallocated]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] pt-0">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="bg-white shadow-md rounded-md">
        <div className="w-full max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-center gap-2 mb-6">
            <img
              src="/stock-black.svg"
              alt="Company Logo"
              className="w-6 h-6"
            />
            <h2 className="text-lg md:text-xl font-semibold text-gray-800 dark:text-gray-200">
              Add Your Trading Stocks
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Auto Fetch Section */}
            <div className="bg-white dark:bg-[#1A1A1A] shadow-md rounded-xl p-6 border border-gray-200 dark:border-[#333]">
              <label
                htmlFor="hinNumber"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Enter HIN Number to Auto-Fetch Stocks
              </label>
              <input
                id="hinNumber"
                name="hinNumber"
                type="text"
                value={hinNumber}
                placeholder="e.g. 1234567890"
                onChange={(e) => {
                  setHinNumber(e.target.value);
                  setIsFetchExist(false);
                  setIsFetchStrategy(false);
                  setManualEntryVisible(false);
                  setIsFetchStrategyCheck(false);
                  // Redux
                  dispatch(setHinNumberRedux(e.target.value));
                  dispatch(setIsFetchExistRedux(false));
                  dispatch(setIsFetchStrategyRedux(false));
                  dispatch(setManualEntryVisibleRedux(false));
                }}
                className="w-full rounded-md h-11 px-4 py-2 border border-gray-300 dark:border-[#4F4F4F] dark:bg-[#101010] dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-black"
              />
              <button
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setIsFetchStrategyRedux(true));
                  setLoading(true);
                  handleFetchStocks(e);
                }}
                disabled={
                  !manualEntryVisible && hinNumber !== "" && !isfetchExist
                    ? false
                    : true
                }
                className={`mt-4 w-full text-sm font-medium py-2 px-4 rounded-full flex items-center justify-center gap-2 transition ${
                  !manualEntryVisible && hinNumber !== "" && !isfetchExist
                    ? "bg-black text-white"
                    : "bg-gray-300 text-gray-600"
                }`}
              >
                {/* SVG icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M6 4v16m12-8v8m-6-12v12"
                  />
                </svg>
                Fetch Stocks
              </button>
            </div>

            {/* Manual Entry Section */}
            <div className="bg-white dark:bg-[#1A1A1A] shadow-md rounded-xl p-6 border border-gray-200 dark:border-[#333]">
              <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
                Prefer to Add Manually or Upload a File?
              </p>

              <div className="flex flex-col gap-y-3">
                {/* Add Manually Button */}
                <button
                  disabled={hinNumber === "" && !isfetchExist ? false : true}
                  onClick={() => {
                    setManualEntryVisible((prev) => !prev);
                    setIsFetch(false);
                    setManualStockList([]);
                    setManualStockCode("");
                    setManualQuantity("");
                    setIsFetchExist(false);
                    setIsFetchStrategy(false);

                    // Redux set
                    dispatch(setIsFetchRedux(false));
                    dispatch(setIsFetchExistRedux(false));
                    dispatch(setIsFetchStrategyRedux(false));
                    dispatch(setManualEntryVisibleRedux((prev) => !prev));
                    dispatch(setManualStockListRedux([]));
                  }}
                  className={`w-full flex items-center justify-center gap-2 text-sm font-medium py-2 px-4 rounded-full transition-colors duration-300 ${
                    hinNumber === "" && !isfetchExist
                      ? "bg-black text-white"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  {manualEntryVisible ? (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                      Cancel
                    </>
                  ) : (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3l-8.5 8.5L10 14l.5-3.5 8-8z"
                        />
                      </svg>
                      Add Manually
                    </>
                  )}
                </button>

                {/* Upload CSV Button */}
                <label
                  htmlFor="csvUpload"
                  disabled={hinNumber === "" && !isfetchExist ? false : true}
                  className={`cursor-pointer w-full flex items-center justify-center gap-2 text-sm font-medium py-2 px-4 rounded-full transition-colors duration-300
                 ${
                   hinNumber === "" && !isfetchExist
                     ? "bg-black text-white"
                     : "bg-gray-300 text-gray-600"
                 }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M4 4v16h16V4H4zm4 8h8M8 12v4m0-4V8"
                    />
                  </svg>
                  Upload CSV
                  <input
                    id="csvUpload"
                    type="file"
                    accept=".csv"
                    className="hidden"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setFile(file);
                        setLoading(true);
                        handleStockCSV(e, file);
                        e.target.value = "";
                      }
                    }}
                  />
                </label>
                {file && (
                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <span className="text-black">{file ? file.name : ""}</span>
                    <button
                      onClick={handleDeleteFile}
                      className="text-red-500 flex-shrink-0 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Success Icon"
                        className="h-4 w-4 flex-shrink-0"
                      />
                    </button>
                  </div>
                )}
                <p
                  onClick={() => {
                    setLoading(true);
                    handleSampleCSV();
                  }}
                  className="underline cursor-pointer text-sm font-medium text-gray-600 dark:text-gray-300 mb-4"
                >
                  Click to download a sample CSV file format
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {manualEntryVisible && hinNumber == "" && (
        <div className="mt-6 bg-white dark:bg-[#1e1e1e] shadow-lg rounded-xl p-4">
          <h3 className="text-base md:text-lg font-semibold text-black dark:text-white mb-3">
            Stock Holdings
          </h3>

          <div className="overflow-x-auto max-h-[60vh]">
            <table className="min-w-full text-sm text-left border border-gray-200 dark:border-gray-700">
              <thead className="bg-[#ECFAFF] text-[#005A9C] text-xs md:text-sm">
                <tr>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Code
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Quantity
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Purchased Date
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-center">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="text-black dark:text-gray-200">
                {/* Inline Input Row */}
                <tr className="bg-gray-50 dark:bg-[#2a2a2a]">
                  <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                    <input
                      type="text"
                      value={manualStockCode}
                      onChange={(e) => setManualStockCode(e.target.value)}
                      placeholder="Stock Code"
                      className="w-full px-2 py-1 text-sm rounded-md border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                    />
                  </td>
                  <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                    <input
                      type="number"
                      value={manualQuantity}
                      onChange={(e) => setManualQuantity(e.target.value)}
                      placeholder="Qty"
                      className="w-full rounded-md px-2 py-1 text-sm rounded border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                    />
                  </td>
                  <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                    <input
                      type="date"
                      value={manualPurchasedDate}
                      onChange={(e) => setManualPurchasedDate(e.target.value)}
                      className="w-full rounded-md px-2 py-1 text-sm border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                    />
                  </td>
                  <td className="w-40 px-4 py-2 border border-gray-300 dark:border-gray-700 text-center">
                    <button
                      onClick={handleAddManualStock}
                      className="bg-[#005A9C] hover:bg-[#004b85] text-white text-xs font-medium py-1 px-3 rounded-full"
                    >
                      Add
                    </button>
                  </td>
                </tr>

                {/* Existing added manual rows */}
                {manualStockList.map((item, index) => (
                  <tr
                    key={index}
                    className="hover:bg-[#f0faff] dark:hover:bg-[#2a2a2a] transition-colors"
                  >
                    {editIndex === index ? (
                      <>
                        {/* Code Input */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                          <input
                            type="text"
                            value={editCode}
                            onChange={(e) => setEditCode(e.target.value)}
                            className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                          />
                        </td>

                        {/* Quantity Input */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          <input
                            type="number"
                            value={editQuantity}
                            onChange={(e) => setEditQuantity(e.target.value)}
                            className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                          />
                        </td>

                        {/* Purchased Date Input */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          <input
                            type="date"
                            value={editPurchasedDate}
                            onChange={(e) =>
                              setEditPurchasedDate(e.target.value)
                            }
                            className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                          />
                        </td>

                        {/* Action Buttons */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 text-center space-x-2">
                          <button
                            onClick={() => handleUpdateSave(index)}
                            className="bg-green-500 hover:bg-green-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Save
                          </button>
                          <button
                            onClick={() => setEditIndex(null)}
                            className="bg-gray-500 hover:bg-gray-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      <>
                        {/* Code Text */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                          {item.code}
                        </td>

                        {/* Quantity Text */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {item.quantity.toLocaleString()}
                        </td>

                        {/* Purchased Date Text */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {formatDateToDDMMYYYY(item.purcahsed_date) || "—"}
                        </td>

                        {/* Action Buttons */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 text-center space-x-2">
                          <button
                            onClick={() => handleEdit(index)}
                            className="bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteManualStock(index)}
                            className="bg-red-500 hover:bg-red-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Delete
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Final Submit Button */}
          {manualStockList.length > 0 && (
            <div className="flex flex-col md:flex-row items-center justify-between mt-6 px-8 py-4 bg-[#FF5050] bg-opacity-20 shadow-md rounded-md space-y-4 md:space-y-0">
              {/* Text Section */}
              <div className="text-center md:text-left flex-1">
                <span className="block text-sm md:text-md font-medium text-black">
                  Upload your stock data to discover applicable strategies
                </span>
              </div>

              {/* Button Section */}
              <div className="text-center md:text-right">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setIsFetchStrategyRedux(true));
                    setLoading(true);
                    handleFetchStocks(e);
                  }}
                  disabled={!isFetchStrategyCheck ? false : true}
                  className={`flex items-center justify-center space-x-2 font-medium py-2 px-4 rounded-full text-sm ${
                    !isFetchStrategyCheck
                      ? "bg-black text-white"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  <span>Upload Now</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {isFetch && isfetchExist && (
        <div className="mt-6 bg-white dark:bg-[#1e1e1e] shadow-lg rounded-xl p-4">
          <h3 className="text-base md:text-lg font-semibold text-black mb-3">
            Stock Holdings
          </h3>

          <div className="overflow-x-auto max-h-[70vh]">
            <table className="min-w-full text-sm text-left border border-gray-200 dark:border-gray-700">
              <thead className="bg-[#ECFAFF] text-[#005A9C] text-xs md:text-sm">
                <tr>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Code
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Stock Name
                  </th>

                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Quantity
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Purchased Date
                  </th>
                </tr>
              </thead>

              {isLoading ? (
                <tbody>
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="animate-pulse">
                      {[...Array(2)].map((_, colIndex) => (
                        <td key={colIndex} className="px-4 py-3">
                          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-black dark:text-gray-200">
                  {stockData.length > 0 ? (
                    stockData.map((row, index) => (
                      <tr
                        key={index}
                        className="hover:bg-[#f0faff] dark:hover:bg-[#2a2a2a] transition-colors"
                      >
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                          {row.asx_code}
                        </td>
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {row.name}
                        </td>
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {row.qty
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {formatDateForFilterNew(row.purchased_date)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        className="text-center text-sm py-6 text-gray-500 dark:text-gray-400"
                      >
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      )}
      <div className="w-full mt-4 p-4 bg-white rounded-lg shadow-lg  relative">
        <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
          <div className="flex items-center">
            <img src="/profile-black.svg" alt="Company Logo" className="mr-3" />
            <span className="font-medium lg:text-xl text-sm">
              Uploaded stock list
            </span>
          </div>
        </div>
        <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
          <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
            <div className="flex items-center space-x-2">
              <span className="lg:text-md  text-sm text-[#8C8C8C]">
                Show Records
              </span>
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilterUnallocated}
                onSelect={handleFilterChange}
              />
            </div>
          </div>
        </div>
        <div>
          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
              {/* Table Header */}
              <thead className="text-labelColour bg-[#F9F9F9] text-sm">
                <tr className="mb-4">
                  {/* Dynamic Headers */}
                  {unallocatedHeaders.map((header) => (
                    <th
                      onClick={() => handleSort(header.key)}
                      key={header.label}
                      className="cursor-pointer font-medium px-4 py-2  border text-left"
                    >
                      <div className="flex items-center justify-between w-full">
                        <span>{header.label}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(10)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm mt-4 font-medium text-black">
                  {stockData.map((account) => (
                    <tr className="px-6 py-2 bg-white">
                      <td className="rounded-l border-l  px-4 py-2 w-40 border-b border-t relative">
                        {account.stock_asx}
                      </td>
                      <td className=" cursor-pointer px-4 py-6 border-b border-t text-left min-w-[200px] max-w-[600px] font-medium flex items-center space-x-2">
                        {account.stock_name}
                      </td>

                      <td className="px-4 py-2 w-40 border-b border-t relative">
                        {account.quantity
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>

                      {/* Dropdown Button */}

                      <td className="px-4 py-2 border-b border-t  text-ellipsis overflow-hidden whitespace-nowrap">
                        <div className="flex items-center space-x-2">
                          <img
                            src="/clock.svg"
                            alt="Time Icon"
                            className="h-4 w-4"
                          />
                          <span className="rounded-xl">
                            {formatDateTime(account.purchase_date)}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-2 w-40 border-b border-t relative rounded-r border-l-0 border">
                        {account.status}
                      </td>
                    </tr>
                  ))}{" "}
                </tbody>
              )}
            </table>
          </div>

          <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
            {/* Entries Info Section */}
            <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
              Showing{" "}
              {showRecordsUnallocated * (currentPageUnallocated - 1) + 1} to{" "}
              {currentPageUnallocated === totalPagesUnallocated ||
              totalPagesUnallocated == 0
                ? totalCountUnallocated
                : Math.max(
                    showRecordsUnallocated * currentPageUnallocated,
                    stockData.length
                  )}{" "}
              of {totalCountUnallocated} entries
            </div>

            {/* Pagination Section */}
            <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
              {/* Previous Button */}
              <button
                disabled={currentPageUnallocated === 1}
                onClick={() => setCurrentPageUnallocated((prev) => prev - 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Prev
              </button>

              {/* Page Buttons */}
              {Array.from({
                length: Math.min(totalPagesUnallocated, 5),
              }).map((_, index) => {
                const startPage = Math.max(
                  1,
                  Math.min(
                    totalPagesUnallocated - 4,
                    currentPageUnallocated - 2
                  )
                );
                const page = startPage + index;

                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPageUnallocated(page)}
                    className={`px-3 py-1 rounded ${
                      currentPageUnallocated === page
                        ? "bg-black text-white"
                        : "bg-white border border-gray-300 text-black"
                    }`}
                  >
                    {page}
                  </button>
                );
              })}

              {/* Next Button */}
              <button
                disabled={currentPageUnallocated === totalPagesUnallocated}
                onClick={() => setCurrentPageUnallocated((prev) => prev + 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="font-medium bg-white mt-6 p-4 rounded-xl shadow-sm border border-gray-200 text-sm text-gray-900">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
          <h3 className="text-base font-semibold text-black flex items-center gap-2">
            {/* Replace with any SVG above */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 7l9-4 9 4-9 4-9-4zm0 6l9 4 9-4m-9 4v5"
              />
            </svg>
            Recommended Strategies
          </h3>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            {/* Show Records */}
            <div className="flex items-center gap-2">
              <span className="text-gray-600">Show</span>
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilter}
                onSelect={handleshowRecord}
              />
            </div>

            {/* Search */}
            <div className="relative w-full sm:w-auto">
              <input
                type="text"
                className="pl-9 pr-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-black focus:outline-none w-full sm:w-60 text-sm"
                placeholder="Search strategy"
                value={searchQuery}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <img
                src="/search-normal.svg"
                alt="Search"
                className="absolute left-3 top-2 w-4 h-4 text-gray-400"
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border-separate border-spacing-y-1 text-sm">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                {portfolioAccountheaders.map((header) => (
                  <th
                    key={header.label}
                    onClick={() => handleSort(header.key)}
                    className="px-4 py-2 text-left font-medium cursor-pointer whitespace-nowrap"
                  >
                    <div className="flex items-center space-x-1">
                      <span>{header.label}</span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoadingPortfolio ? (
                [...Array(5)].map((_, i) => (
                  <tr
                    key={i}
                    className="rounded border border-gray-100 bg-white"
                  >
                    {[...Array(4)].map((_, j) => (
                      <td key={j} className="px-4 py-3">
                        <div className="h-3 bg-gray-200 rounded animate-pulse"></div>
                      </td>
                    ))}
                  </tr>
                ))
              ) : portfolioAccounttableData.length > 0 ? (
                portfolioAccounttableData.map((row, index) => (
                  <tr
                    key={index}
                    className={`transition-colors border border-gray-100 ${
                      index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-indigo-50`}
                  >
                    <td className="px-4 py-3 whitespace-nowrap">
                      {row.ref_code}
                    </td>
                    <td
                      onClick={() => {
                        let redirectState = {
                          path: "/strategy-details",
                          state: {
                            from: location.pathname,
                            strategyid: row.strategy_id,
                            strategyName: row.strategy_name,
                            showInvest: false,

                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        };
                        sessionStorage.setItem(
                          "redirectAfterLogin",
                          JSON.stringify(redirectState)
                        );
                        navigate("/strategy-details", {
                          state: {
                            from: location.pathname,
                            strategyid: row.strategy_id,
                            strategyName: row.strategy_name,
                            showInvest: false,

                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        });
                      }}
                      className="px-4 py-3 text-[#005A9C] hover:underline cursor-pointer whitespace-normal font-medium"
                    >
                      Caprock Model portfolio - {row.strategy_name}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap font-semibold text-emerald-600">
                      {row.overall_matching_percentage
                        ? row.overall_matching_percentage.toFixed(2) + "%"
                        : "0.00"}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      $
                      {row.overall_matching_percentage
                        ? row.minimum_investment
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={4}
                    className="px-4 py-4 text-center text-gray-500"
                  >
                    No results found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {!isLoading && (
          <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-gray-700 text-xs gap-3">
            <div>
              Showing {showRecords * (currentPage - 1) + 1} to{" "}
              {currentPage === totalPages || totalPages === 0
                ? totalCount
                : Math.min(showRecords * currentPage, totalCount)}{" "}
              of {totalCount} entries
            </div>
            <div className="flex gap-1">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: Math.min(totalPages, 5) }).map((_, i) => {
                const startPage = Math.max(
                  1,
                  Math.min(totalPages - 4, currentPage - 2)
                );
                const page = startPage + i;
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-2.5 py-1 rounded ${
                      currentPage === page
                        ? "bg-black text-white font-semibold"
                        : "bg-white border border-gray-300 hover:bg-gray-100"
                    }`}
                  >
                    {page}
                  </button>
                );
              })}
              <button
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadStocks;
